export default __webpack_public_path__ + "static/p5-013da98dd2c3ff788c04b9f6b305d390.png";